import { ProductConditionSummary } from 'src/types';
import { IProductCondition } from '../../product-conditions/types';
import { getConditions } from '../../product-conditions/utils';
import { PriceDisplay } from 'src/areas/product/types';

export const getPriceRange = (
  conditions: ProductConditionSummary[],
  selectedCondition: string,
  priceDisplay: PriceDisplay
): IProductCondition | undefined => {
  const conditionsWithCalcShipping = getConditions(conditions, priceDisplay);
  return conditionsWithCalcShipping.find(c => c.name === selectedCondition);
};
